import { useSelector } from "react-redux";
import { useAppDispatch } from "../store/store";
import { RootState } from "../store/store";
import { login, logout } from "../redux/authSlice";

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, isAuthChecking, userRoles, userName } = useSelector(
    (state: RootState) => state.auth,
  );

  return {
    isAuthenticated,
    isAuthChecking,
    userRoles,
    userName,
    login: () =>
      dispatch(login()).catch((err) => console.error("Login failed", err)),
    logout: () =>
      dispatch(logout()).catch((err) => console.error("Logout failed", err)),
  };
};
